import { msg } from "@lingui/core/macro";

import type { BuildKind } from "./HeroBuilds";

// Тип сборки на экране «Сборки»: заголовок группы и подпись в полосе долей.
export const BUILD_KIND_LABEL = msg({
  id: "builds.kind",
  message: "{kind, select, melee {Melee} spirit {Spirit} weapon {Gun} other {Mixed}}",
});

// Цвет типа: спирит и оружие — цвета веток магазина, мили — красный, смешанная — серый.
export const BUILD_KIND_COLOR: Record<BuildKind, string> = {
  spirit: "bg-slot-spirit",
  weapon: "bg-slot-weapon",
  melee: "bg-bad",
  mixed: "bg-neutral",
};
